import React, { useEffect } from 'react';
import { ConfigProvider, App } from 'antd';
import { intercom } from '@acast-tech/product-suite-app-utils';
import { Outlet } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import en_US from 'antd/locale/en_US';
import fr_FR from 'antd/locale/fr_FR';
const LOCALES = { en: en_US, fr: fr_FR };
import Internationalization from './PublicInternationalization';
import { getAvailableLanguageFromNavigator } from '../../utils/i18nUtils';
import config from '../../config';
import packageInfo from '../../../../../package.json';
import publicTheme from '../../../themes/public';

const BasePublic = () => {
  useEffect(() => {
    intercom.load(config.intercomAppId);
    intercom.boot();

    mixpanel.init(config.mixpanelToken, {
      debug: config.env !== 'prod',
      track_pageview: true,
      persistence: 'localStorage',
      record_sessions_percent: 0.05,
    });

    // eslint-disable-next-line no-console
    console.log(`[Acast Public] v ${packageInfo.version} @${config.version}`);
  }, []);

  const locale = getAvailableLanguageFromNavigator() || 'en';
  const antdLocale = LOCALES[locale] || en_US;

  return (
    <Internationalization>
      <ConfigProvider locale={antdLocale} theme={publicTheme}>
        <App>
          <Outlet />
        </App>
      </ConfigProvider>
    </Internationalization>
  );
};

export default BasePublic;
